<template>
    <div>
        <label :class="['label',  {'label--required': required}]" :for="name">
            <slot></slot>
        </label>
        <select
            class="form-select"
            :name="name"
            :value="selectedValue"
            :disabled="disabled"
            @input="$emit('input', $event.target.value)"
            >
            <option
                v-for="(option, index) in options"
                :value="option.value"
                :key="index"
            >
                {{ option.label }}
            </option>
        </select>
        <span class="invalid-feedback" v-if="computedError">
            <strong>{{ computedError }}</strong>
        </span>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'selectedValue',
            event: 'input'
        },

        props: {
            required: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            name: '',
            selectedValue:'',
            options: {},
        },

        data() {
            return {

            }
        },

        computed: {
            computedError() {
                return this.error || this.errors(this.name);
            }
        },

        methods: {
        }
    }
</script>
